import styles from "./VenuesPage.module.scss";
import { useTranslation } from "react-i18next";
import Button from "../../components/Button/Button";
import useOnClickFunctions from "../../components/Drawer/helpers/onClickFunctions";
import { useParams } from "react-router-dom";
import { useVenuesDataStore } from "@/store/useVenuesDataStore";
import { billsPath, menuPath, orderPaths, tipPath } from "@/routes/paths";

function VenuesPage() {
  const { t } = useTranslation();

  const { handleNavigate } = useOnClickFunctions();
  const { restaurantId, tableId } = useParams();
  const { totalAmount, tableNumber } = useVenuesDataStore();

  const hasActiveOrder = totalAmount > 0;

  return (
    <div className={styles.venuePageWrapper}>
      <div className={styles.headerContainer}>
        <p className={`body-bold-medium ${styles.headerTableDescription}`}>
          {t("venuePage.header.tableDescription")} {tableNumber ?? "12"}
        </p>
        <p className={`body-medium ${styles.headerTitle}`}>
          {t("venuePage.header.title")}
        </p>
        {/* One group, so the choices read together rather than as sections. */}
        <div className={styles.headerActions}>
          <Button
            onClick={() =>
              handleNavigate(orderPaths(restaurantId ?? "", tableId ?? "").root)
            }
            label={t("venuePage.header.orderButtonLabel")}
            icon="las la-utensils icon-medium"
            variant="contained"
            color="primary"
            maxWidth
            mobile={true}
          />
          <Button
            onClick={() => handleNavigate(menuPath(restaurantId ?? ""))}
            label={t("venuePage.header.menuButtonLabel")}
            icon="las la-book-open icon-medium"
            variant="contained"
            color="primary"
            maxWidth
            mobile={true}
          />
          {/* Thanking one person is its own errand, not a step of paying. */}
          <Button
            onClick={() =>
              handleNavigate(tipPath(restaurantId ?? "", tableId ?? ""))
            }
            label={t("venuePage.header.tipButtonLabel")}
            icon="las la-hand-holding-usd icon-medium"
            variant="contained"
            color="primary"
            maxWidth
            mobile={true}
          />
          {hasActiveOrder ? (
            <Button
              onClick={() => {
                handleNavigate(billsPath(restaurantId ?? "", tableId ?? ""));
              }}
              label={t("venuePage.header.payButtonLabel")}
              icon="las la-receipt icon-medium"
              variant="contained"
              color="primary"
              maxWidth
              mobile={true}
            />
          ) : null}
        </div>
        {hasActiveOrder ? null : (
          <p className={`body-medium ${styles.noOrderText}`}>
            {t("venuePage.header.noActiveOrder")}
          </p>
        )}
      </div>
    </div>
  );
}

export default VenuesPage;
